export default "__VITE_ASSET__agB1ksKl__"